<template>
    <div class="html-modal-wrap">
        <div class="icon-wrap" @click="closeModal">
            <span class="material-icons">close</span>
        </div>
        <div 
            class="video-wrap"
            :class="{ 'isBBB' : isBBB, 'transparent': item.isTransparent === 'true' || item.isTransparent === true }"
        >
            <iframe
                :src="htmlSrc"
                v-bind="bbbIframeAttributes"
                allowfullscreen="allowfullscreen"
                frameborder="0"
            ></iframe>
        </div>
    </div>
</template>

<script>
import isMobileMixin from "../../mixins/isMobileMixin";
export default {
    props: {
        // can contain clickable item info and/or customUrl src for iframe
        item: {
            type: Object,
            required: true,
        },
    },
    mixins: [isMobileMixin],
    computed: {
        isBBB () {
            return this.item.type === 'bbb_modal';
        },
        htmlSrc () {
            return this.item.customUrl || `${process.env.VUE_APP_VIDEO_BASE}/api/content/${this.item.con_id}`;
        },
        bbbIframeAttributes () {
            const atts = {
                sandbox: "allow-same-origin allow-top-navigation allow-scripts allow-modals allow-forms allow-popups",
                allow:"geolocation *; microphone *; camera *; display-capture *; accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            };

            return this.isBBB? atts: null;
        },
    },
    mounted () {
        window.addEventListener('keydown', this.handleEvent)
        console.log(this.item);
    },
    methods: {
        closeModal () {
            window.removeEventListener('keydown', this.handleEvent)
            this.$emit('close-modal')
        },
        handleEvent (e) {
            if (parseInt(e.keyCode) === 27) {
                this.closeModal()
            }
        }
    },
}
</script>

<style scoped lang="scss">
.html-modal-wrap {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: #000000bb;
    // more than jira
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
}
.video-wrap {
    width: 80%;
    max-height: 100vh;
    height: 80%;
    @media screen and (max-width: 900px) {
        width: 100%;
        height: 50%;
    }
    background: #fff;
    &.isBBB {
        width: 90%;
        height: 90%;
    }
    &.transparent {
       background: transparent;
    }
}
.icon-wrap {
    cursor: pointer;
    position: absolute;
    color: #fff;
    top: 3%;
    right: 3%;
}
iframe {
    width: 100%;
    height: 100%;
}
</style>